import { Outlet, useNavigate } from "react-router-dom";
import {
  useLazyGetCustomerLobDetailsQuery,
  useLazyGetInternalTokenQuery,
  useLazyMPinExistQuery,
} from "../../features/Feature_Login/Login_Api";
import { FC, ReactNode, useCallback, useEffect, useState } from "react";
import {
  useAppDispatch,
  useAppSelector,
} from "../../redux-store/CustomReduxHooks";
import CsLocalStorageUtils from "../../utils/CsLocalStorageUtils";
import { setError } from "../../redux-store/reducers/CsErrorSlice";
import {
  saveCsUserId,
  setCustomerAndLobDetails,
  setLongSessionAuthToken,
} from "../../redux-store/reducers/CsAppSlice";
import { updateLoadingState } from "../../features/Feature_Loading/Loading_Slice";
import {
  resetLoginData,
  updateScreenTag,
} from "../../features/Feature_Login/Login_Slice";
import {
  E_ChannelOptions,
  J_FunctionalityCode,
  LoginScreenValues,
  T_ApiResponse,
  T_CustomerLobDetails,
} from "../../globalTypes/GlobalTypes";
import CsSessionStorageUtils from "../../utils/CsSessionStorageUtils";
import { API_STATUS_CODE } from "../../utils/ApiEndpoints";
import { isEmpty } from "lodash";
import {
  useLazyFetchAppPermissionQuery,
  useLazyLogoutApiQuery,
} from "../../features/Feature_GeneralAppElements/GeneralAppElements_Api";
import { T_GetCustomerLobDetailsRes } from "../../features/Feature_Login/Login_Types";
import CustomMultipleSessionPopUp from "../../components/CustomMultipleSessionPopUp/CustomMultipleSessionPopUp";
import useProfileAndSaveCampaignApi from "../../hooks/useProfileAndSaveCampaignApi";
import useDeviceDetection from "../../hooks/useDeviceDetection";
import {
  ABCDHoldingsLobCode,
  DEVICE_TYPE,
  onUserLoginCleverTapStatic,
  SCREEN_TYPE,
} from "../../utils/constants";
import {
  setAppPermission,
  setIsNoHolding,
} from "../../features/Feature_GeneralAppElements/GeneralAppElements_Slice";
import { T_Update_App_Permission_Request } from "../../features/Feature_GeneralAppElements/GeneralAppElements_Types";
import useQuickActionMenu from "../../hooks/useQuickActionMenu";
import {
  R_GeneralElementsRoutes,
  R_HomeRoutes,
  R_OnBoardingRoutes,
} from "../../utils/Routes";
import cleverTap, { triggerCleverTapEvent } from "../../utils/CleverTap";
import { useLazyFetchUserProductStatusQuery } from "../../features/Feature_ABCD/Feature_ABCD_Api";
import { setUserProductStatusDetails } from "../../features/Feature_ABCD/Feature_ABCD_Slice";

type T_AuthGuardProps = {
  showCustomLoading?: boolean;
  initFlag?: boolean;
  resultCallback?: Function;
  fallbackUi?: ReactNode;
};
const AuthGuard: FC<T_AuthGuardProps> = ({
  showCustomLoading = false,
  initFlag = true,
  resultCallback,
  fallbackUi = null,
}) => {
  const csAppSlice = useAppSelector((state) => state.CsAppSlice);
  const tokenDetails = csAppSlice?.tokenDetails;
  const userDetails = csAppSlice?.userDetails;
  const loginSlice = useAppSelector((state) => state.LoginSlice);
  const SsoSlice = useAppSelector((state) => state.SsoSlice.ssoData);
  const deviceType = useDeviceDetection();
  const SecondaryChannelSlice = useAppSelector(
    (state) => state.SecondaryChannelSlice
  );
  const userProductStatusDetails = useAppSelector(
    (state) => state.ABCDHoldingsSlice.userProductStatusData
  );
  const navigate = useNavigate();
  const [decidingNextRoute, setDecidingNextRoute] = useState(true);
  const [showPopup, setShowPopup] = useState(false);
  const [popupError, setPopupError] = useState<any>(null);
  const appDispatch = useAppDispatch();
  const [getCustomerLobDetails, { data: customerAndLobDetailsResponse }] =
    useLazyGetCustomerLobDetailsQuery();
  const [getInternalToken, { data: dataToken }] =
    useLazyGetInternalTokenQuery();
  const [mPinCheckApi, { isFetching: isCheckingMpin }] =
    useLazyMPinExistQuery();
  const internalAuthToken = useAppSelector(
    (state) => state.CsAppSlice?.tokenDetails?.internal
  );
  const [csLobDetails, setCsLobDetails] =
    useState<T_ApiResponse<T_GetCustomerLobDetailsRes>>();
  const [mobileNumber, setMobileNumber] = useState();
  const [getLogOutApi] = useLazyLogoutApiQuery();
  const getProfileDetailApi = useProfileAndSaveCampaignApi();
  const [fetchAppPermission] = useLazyFetchAppPermissionQuery();
  const [fetchUserProductStatusApi] = useLazyFetchUserProductStatusQuery();

  useQuickActionMenu();

  useEffect(() => {
    if (initFlag) {
      init();
    }
  }, [
    userDetails?.customerAndLobDetails,
    internalAuthToken,
    initFlag,
    loginSlice.csAndLobDetails,
  ]);

  const init = useCallback(async () => {
    if (isEmpty(userDetails?.customerAndLobDetails)) {
      appDispatch(setIsNoHolding(true));
    } else {
      appDispatch(setIsNoHolding(false));
    }
    if (!userDetails?.customerAndLobDetails && loginSlice.isUserLoggedIn) {
      CsSessionStorageUtils.clear("ACTIVE_DASHBOARD_TAB");
      let mobileNoFromStorage = CsLocalStorageUtils.get("MOBILE");
      const allowedChannels = [
        E_ChannelOptions.SUPER_APP,
        E_ChannelOptions.ONE_ABC,
        E_ChannelOptions.ABSLI,
        E_ChannelOptions.ABHI,
        E_ChannelOptions.ABSLAMC,
        E_ChannelOptions.ABML,
        E_ChannelOptions.ABHFL,
        E_ChannelOptions.ABFL,
      ];
      const mobile = allowedChannels.includes(csAppSlice?.channel)
        ? SsoSlice.mobileNo
        : loginSlice.mobilenumber || mobileNoFromStorage;
      if (!mobile) {
        gotoLogin();
        return;
      }
      setMobileNumber(mobile);
      manageLoading(true);
      let response;
      if (!isEmpty(loginSlice?.csAndLobDetails)) {
        response = { data: loginSlice.csAndLobDetails };
      } else {
        response = await getCustomerLobDetails({ mobile: mobile });
      }
      // getCustomerLobDetails({ mobile: mobile })
      //   .then((response) => {
      setCsLobDetails(response.data);
      setDecidingNextRoute(true);
      if (response.error || !response.data?.payload?.customerAndLobDetails) {
        let onUserLoginCleverTapData = { ...onUserLoginCleverTapStatic };
        onUserLoginCleverTapData["Identity"] = "+91" + mobile;
        onUserLoginCleverTapData["MSG-push"] = !isEmpty(
          csAppSlice?.NativeDeviceInfo?.deviceName
        );
        cleverTap.onUserLogin.push({ Site: onUserLoginCleverTapData });
        triggerCleverTapEvent("onUserLogin", {
          ScreenType: SCREEN_TYPE.DashboardScreenType,
          ScreenName: "Servicing Homescreen",
          isPrevPageNameRequired: true,
          ...onUserLoginCleverTapData,
          MSG_email: onUserLoginCleverTapData["MSG-email"],
          MSG_push: onUserLoginCleverTapData["MSG-push"],
          MSG_sms: onUserLoginCleverTapData["MSG-sms"],
          MSG_whatsapp: onUserLoginCleverTapData["MSG-whatsapp"],
        });
        showError(new Error("error"));
        gotoLogin();
        return;
      }
      if (response.data?.code === API_STATUS_CODE.SUCCESS) {
        appDispatch(saveCsUserId(response.data.payload.CS_USER_ID));
        fetchUserProductStatusApiFun(response.data?.payload, mobile);
        if (csAppSlice?.tokenDetails?.internal?.longSessionAuthToken) {
          getProfileDetailApi(response.data?.payload);
          navigateToUrl(response.data?.payload);
          return;
        }
        getInternalTokenApi(response.data);
      } else {
        showError(new Error(JSON.stringify(response.data)));
      }
      // })
      // .catch((err) => {
      //   showError(err);
      // });
    } else if (!loginSlice.isUserLoggedIn) {
      gotoLogin();
    } else if (
      !userDetails?.IS_USER_REGISTERED &&
      csAppSlice?.channel != E_ChannelOptions.ONE_ABC &&
      csAppSlice?.tokenDetails?.internal.longSessionAuthToken
    ) {
      navigateToUrl(userDetails);
    } else {
      setDecidingNextRoute(false);
    }
  }, [userDetails?.customerAndLobDetails, internalAuthToken]);

  const manageLoading = useCallback(
    (showLoading: boolean = false) => {
      if (showCustomLoading) {
        return;
      }
      appDispatch(updateLoadingState(showLoading));
    },
    [appDispatch, updateLoadingState, showCustomLoading]
  );

  const getAppPermissions = async (userId: string) => {
    try {
      const response = await fetchAppPermission({
        mobileNo: mobileNumber || loginSlice.mobilenumber || "",
        csUserId: userId,
      });

      if (
        response.data?.code === API_STATUS_CODE.SUCCESS &&
        !isEmpty(response.data?.payload)
      ) {
        let res = response.data?.payload;
        let updatePermissionData: T_Update_App_Permission_Request = {
          csUserId: res.csUserId,
          mobileNumber: res.mobileNumber,
          permissions: {
            tncConsent: res.tncConsent || false,
            privacyConsent: res.privacyConsent || false,
            whatsapp: res.whatsappConsent || false,
            camera: res.cameraPermission || false,
            notifications: res.notificationsPermission || false,
            contact: res.contactsPermission || false,
            call: res.callLogsPermission || false,
            sms: res.messagesPermission || false,
            location: res.locationEnabled || false,
            storage: res.storageEnabled || false,
            displayOverOtherApps: res.displayOverOtherAppsEnabled || false,
          },
        };
        appDispatch(setAppPermission(updatePermissionData));
      } else {
        // appDispatch(
        //   setError({
        //     error: response.error as T_ApiResponse<any>,
        //     message: "failed",
        //   })
        // );
      }
    } catch (e) {
      appDispatch(
        setError({
          error: new Error(),
          message: "failed",
        })
      );
    }
  };

  const checkIfMpinExists = () => {
    /** will be going throught AuthGuard, if new user
     * then would be redirected to onboarding screen
     */
    const mobileNo = mobileNumber || loginSlice.mobilenumber;
    mPinCheckApi({
      mobileNo: mobileNo,
    }).then((res) => {
      if (res.data?.code === API_STATUS_CODE.SUCCESS) {
        if (res.data.payload.mpinExist) {
          CsLocalStorageUtils.set("MPIN_FOR_MOBILE", mobileNo);
          appDispatch(updateScreenTag(LoginScreenValues.LoginWithMPIN));
          setDecidingNextRoute(false);
          navigate("/login", { replace: true });
        } else {
          CsLocalStorageUtils.set("MPIN_FOR_MOBILE", "");
          navigate(R_GeneralElementsRoutes.setMpin, {
            replace: true,
            state: { type: "createMpin" },
          });
        }
      } else {
        appDispatch(
          setError({
            error: new Error("Error"),
            message: "Check Mpin Exist Api Failed",
          })
        );
        setDecidingNextRoute(false);
      }
    });
  };

  const showError = (err: Error) => {
    appDispatch(setError({ error: err, message: err.message }));
  };

  const gotoLogin = () => {
    appDispatch(resetLoginData());
    navigate("/login", { replace: true });
  };

  const saveCsUserIdToLocalStorage = (csUserId: string) => {
    CsLocalStorageUtils.set("CS_USER_ID", csUserId);
  };

  const saveMobileToLocalStorage = (mobile: string) => {
    CsLocalStorageUtils.set("MOBILE", mobile);
  };

  const gotoNoHoldingsPage = () => {
    // navigate(R_HomeRoutes.noHoldings, { replace: true });
    appDispatch(setIsNoHolding(true));
    navigate(R_HomeRoutes.home, { replace: true });
    manageLoading(false);
  };

  const gotoOnBoardingPage = () => {
    appDispatch(updateScreenTag(LoginScreenValues.enterUserDetailScreen));
    navigate(R_OnBoardingRoutes.onboarding, { replace: true });
  };

  const navigateToUrl = (
    userDetailsValue: T_CustomerLobDetails | undefined
  ) => {
    if (!userDetailsValue?.IS_USER_REGISTERED) {
      if (csAppSlice?.channel != E_ChannelOptions.ONE_ABC) {
        gotoOnBoardingPage();
      }
    } else if (
      (deviceType === DEVICE_TYPE.PWA_MOBILE ||
        deviceType === DEVICE_TYPE.MOBILE) &&
      !isEmpty(csAppSlice?.NativeDeviceInfo?.deviceName) &&
      csAppSlice?.channel === E_ChannelOptions.CSAPP &&
      loginSlice.screenTag !== LoginScreenValues.LoginWithMPIN &&
      CsLocalStorageUtils.get("MPIN_FOR_MOBILE") !==
        CsLocalStorageUtils.get("MOBILE")
    ) {
      checkIfMpinExists();
      return;
    } else if (csAppSlice?.channel === E_ChannelOptions.SECONDARY_CHANNEL) {
      navigate(SecondaryChannelSlice.constructedAppUrl, {
        state: SecondaryChannelSlice.dynamicState,
        replace: true,
      });
    } else if (
      window.location.pathname.includes(R_OnBoardingRoutes.onboarding)
    ) {
      navigate(R_HomeRoutes.home, { replace: true });
    } else if (isEmpty(userDetailsValue.customerAndLobDetails)) {
      gotoNoHoldingsPage();
    }
    setDecidingNextRoute(false);
  };

  const logoutPreviousSession = async () => {
    setShowPopup(false);
    setPopupError(false);
    manageLoading(true);
    await getLogOutApi({
      csUserId: "" + userDetails?.CS_USER_ID,
    });
    if (csLobDetails) {
      getInternalTokenApi(csLobDetails);
    }
    // manageLoading(false)
  };

  const fetchUserProductStatusApiFun = (
    csLOBDe: T_GetCustomerLobDetailsRes,
    mobile: string
  ) => {
    if (isEmpty(csLOBDe.customerAndLobDetails)) {
      return;
    }
    let abcdHolding = csLOBDe.customerAndLobDetails.filter((c) => {
      return c.LOB === ABCDHoldingsLobCode;
    });

    if (!isEmpty(abcdHolding)) {
      fetchUserProductStatusApi({
        mobileNumber: mobile,
      }).then((res) => {
        if (
          res.error ||
          res.isError ||
          res.data?.code !== API_STATUS_CODE.SUCCESS
        ) {
          appDispatch(
            setError({
              error: new Error(),
              message: "fetchUserProductStatusApi api failed",
            })
          );
        }
        if (res.data?.code === API_STATUS_CODE.SUCCESS) {
          appDispatch(setUserProductStatusDetails(res.data?.payload?.data));
        }
      });
    }
  };

  const getInternalTokenApi = (
    csLOBDe: T_ApiResponse<T_GetCustomerLobDetailsRes>
  ) => {
    manageLoading(true);
    if (csLOBDe?.payload?.CS_USER_ID) {
      getInternalToken(csLOBDe?.payload?.CS_USER_ID).then((tokenResponse) => {
        if (tokenResponse.data?.code === API_STATUS_CODE.SUCCESS) {
          getProfileDetailApi(csLOBDe?.payload);
          getAppPermissions(csLOBDe?.payload.CS_USER_ID);
          if (!csLOBDe?.payload) {
            gotoNoHoldingsPage();
            return;
          }
          if (
            !isEmpty(SsoSlice?.functionality) &&
            csAppSlice?.channel === E_ChannelOptions.ONE_ABC
          ) {
            const funcObj = J_FunctionalityCode.find(
              (j) => j.funcCode === (SsoSlice?.functionality || "")
            );
            let filteredCustomerLobArr = { ...csLOBDe.payload };
            if (funcObj && !isEmpty(csLOBDe.payload.customerAndLobDetails)) {
              filteredCustomerLobArr.customerAndLobDetails =
                csLOBDe.payload.customerAndLobDetails.filter((c) =>
                  funcObj?.lobCode?.includes(c.LOB_CODE)
                );
            }
            appDispatch(setCustomerAndLobDetails(filteredCustomerLobArr));
          } else {
            appDispatch(setCustomerAndLobDetails(csLOBDe?.payload));
          }
          saveCsUserIdToLocalStorage(csLOBDe?.payload.CS_USER_ID);
          // saveMobileToLocalStorage(mobileNumber);
          appDispatch(
            setLongSessionAuthToken(tokenResponse.data.payload.authToken)
          );
          navigateToUrl(csLOBDe.payload);
        } else if (
          tokenResponse.data?.code === API_STATUS_CODE.BUSINESS_ERROR
        ) {
          manageLoading(false);
          setPopupError(true);
          setShowPopup(true);
        } else if (tokenResponse.error) {
          showError(tokenResponse.error as Error);
          gotoLogin();
          return;
        }
      });
    }
    // manageLoading(false)
  };

  const authPassed = popupError
    ? false
    : !userDetails?.customerAndLobDetails ||
      !tokenDetails?.internal.longSessionAuthToken ||
      decidingNextRoute
    ? false
    : isCheckingMpin
    ? false
    : true;

  if (resultCallback) {
    resultCallback(authPassed);
  }

  return (
    <>
      {popupError && (
        <CustomMultipleSessionPopUp
          gotoLogin={() => appDispatch({ type: "USER_LOGOUT" })}
          logoutPreviousSession={() => logoutPreviousSession()}
          open={showPopup}
        />
      )}
      {!userDetails?.customerAndLobDetails ||
      !tokenDetails?.internal.longSessionAuthToken ||
      decidingNextRoute ? (
        <></>
      ) : isCheckingMpin ? (
        <></>
      ) : fallbackUi ? (
        fallbackUi
      ) : (
        <Outlet />
      )}
    </>
  );
};

export { AuthGuard };
